import { createContext, useState, useContext, ReactNode } from "react";

interface Props {
    children?: ReactNode;
}

interface authProps {
    isAuthenticated?: boolean;
    isTokenLoaded?: boolean;
    isErrorTokenLogin?: boolean;
    messageErrorTokenLogin?: string;
    login?: Function;
    logout?: Function;
    loadedToken?: Function;
    cleanLoadedToken?: Function;
    errorTokenLogin?: Function;
    putErrorTokenMessage?: Function;
}

const AuthContext = createContext<authProps>({});

export const useAuth = () => {
    const auth = useContext(AuthContext);
    return auth;
};

export const AuthProvider = ({ children }: Props) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [isTokenLoaded, setIsTokenLoaded] = useState<boolean>(false);
    const [isErrorTokenLogin, setIsErrorTokenLogin] = useState<boolean>(false);
    const [messageErrorTokenLogin, setMessageErrorTokenLogin] = useState<string>("");

    const login = () => {
        setIsAuthenticated(true);
    };

    const logout = () => {
        setIsAuthenticated(false);
    };

    const loadedToken = () => {
        setIsTokenLoaded(true)
    };
    const cleanLoadedToken = () => {
        setIsTokenLoaded(false)
    };
    const errorTokenLogin = (error: boolean) => {
        setIsErrorTokenLogin(error);
    };

    const putErrorTokenMessage = (message: string) => {
        setMessageErrorTokenLogin(message);
    };

    const values = {
        isAuthenticated: isAuthenticated,
        isTokenLoaded: isTokenLoaded,
        isErrorTokenLogin: isErrorTokenLogin,
        messageErrorTokenLogin: messageErrorTokenLogin,
        login: login,
        logout: logout,
        loadedToken: loadedToken,
        cleanLoadedToken: cleanLoadedToken,
        errorTokenLogin: errorTokenLogin,
        putErrorTokenMessage: putErrorTokenMessage
    };
    return <AuthContext.Provider value={values}>{children}</AuthContext.Provider>;
};
